<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expand-all="true"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="20" style="margin-bottom: 15px">
          <behavior-list ref="behaviorList" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import behaviorList from './behavior-list';
  import { finiteDataTree } from '@/config/api'; //修改角色权限

  export default {
    name: 'Index',
    components: { behaviorList },
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        // current: null,  // 选中数据
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      formatDate(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let hh = date.getHours();
        let mm = date.getMinutes();
        // let ss = date.getSeconds();
        if (m < 10) {
          m = 0 + '' + m;
        }
        if (d < 10) {
          d = 0 + '' + d;
        }
        if (hh < 10) {
          hh = 0 + '' + hh;
        }
        if (mm < 10) {
          mm = 0 + '' + mm;
        }
        // if (ss < 10) {
        //   ss = 0 + '' + ss;
        // }
        return y + '-' + m + '-' + d; //格式可以在这调整
      },
      query() {
        this.loading = true;
        finiteDataTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData = res.data.data;
              setTimeout(() => {
                this.choose(this.deptData[0].children[0].children[0].children[0]);
              }, 100);
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },

      /* 选择数据 */
      choose(row) {
        // if (row.orgType === 4) {
        this.$refs.orgTree.setCurrentKey(row.id);
        let obj = {
          classId: row.id.slice(1),
          orgType: row.orgType,
          startDate: this.formatDate(new Date()),
          overDate: this.formatDate(new Date()),
        };
        this.$refs.behaviorList.classId = row.id.slice(1);
        this.$refs.behaviorList.table.where = obj;
        this.$refs.behaviorList.$refs.table.reload();
        // }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
